import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Shield,
    ArrowLeft,
    CheckCircle2,
    Activity,
    Database,
    Lock,
    Zap,
    FileText,
    Server
} from 'lucide-react';

const ServiceERP = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const shieldFeatures = [
        {
            title: "Monitoreo Proactivo",
            icon: <Activity size={24} color="#00FFD1" />,
            improvements: [
                "Alertas preventivas ante picos de carga en CPU/RAM.",
                "Detección de caídas de servicio en tiempo real.",
                "Visibilidad total del tráfico entrante y saliente.",
                "Dashboard de salud técnica disponible 24/7."
            ]
        },
        {
            title: "Backups de Grado Crítico",
            icon: <Database size={24} color="#00FFD1" />,
            improvements: [
                "Automatización total de copias de seguridad diarias.",
                "Cifrado de grado militar para la protección de datos.",
                "Almacenamiento redundante fuera del servidor local.",
                "Pruebas de restauración periódicas garantizadas."
            ]
        },
        {
            title: "Hardening & DR",
            icon: <Lock size={24} color="#00FFD1" />,
            improvements: [
                "Blindaje del Kernel Linux contra vulnerabilidades.",
                "Plan de recuperación ante desastres (Disaster Recovery).",
                "Configuración de firewall perimetral y WAF.",
                "Aislamiento de procesos para evitar intrusiones."
            ]
        },
        {
            title: "Optimización de Datos",
            icon: <Zap size={24} color="#00FFD1" />,
            improvements: [
                "Tuning de parámetros para consultas de alto rendimiento.",
                "Optimización de índices y mantenimiento preventivo.",
                "Reducción drástica en tiempos de reportes complejos.",
                "Balanceo de carga de escritura y lectura en disco."
            ]
        },
        {
            title: "Auditoría de Sistemas",
            icon: <FileText size={24} color="#00FFD1" />,
            improvements: [
                "Rastreo detallado de logs de acceso por usuario.",
                "Detección de cambios no autorizados en el sistema.",
                "Cumplimiento de estándares de seguridad internos.",
                "Reportes mensuales de integridad técnica y seguridad."
            ]
        }
    ];

    return (
        <div style={{
            background: '#000000',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'sans-serif',
            color: '#FFFFFF'
        }}>
            {/* Navegación Superior */}
            <nav style={{
                padding: '30px 7.6923%',
                display: 'flex',
                alignItems: 'center'
            }}>
                <Link to="/" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#00FFD1',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: 500
                }}>
                    <ArrowLeft size={16} />
                    Regresar al Inicio
                </Link>
            </nav>

            <main style={{
                flex: 1,
                padding: '20px 7.6923% 80px',
                maxWidth: '1200px',
                margin: '0 auto',
                width: '100%'
            }}>

                {/* Header Unificado */}
                <div style={{ textAlign: 'center', marginBottom: '80px' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '6px 14px',
                        background: 'rgba(0, 255, 209, 0.1)',
                        marginBottom: '24px',
                        border: '1px solid rgba(0, 255, 209, 0.2)'
                    }}>
                        <Shield size={16} color="#00FFD1" />
                        <span style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '1.5px', color: '#00FFD1' }}>INFRAESTRUCTURA CRÍTICA</span>
                    </div>

                    <h1 style={{ fontSize: 'clamp(32px, 5vw, 56px)', fontWeight: 700, marginBottom: '20px' }}>
                        Pixelinux <span style={{ color: '#00FFD1' }}>ERP Shield</span>
                    </h1>
                    <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '18px', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
                        Blindamos la continuidad operativa de tus sistemas empresariales.
                        Soporte especializado para infraestructuras de <strong>Odoo, SAP Business One y Microsip</strong> sobre entornos Linux de alto rendimiento.
                    </p>
                </div>

                {/* Grid de Capacidades Técnicas */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
                    gap: '24px',
                    alignItems: 'stretch'
                }}>
                    {shieldFeatures.map((feature, index) => (
                        <div key={index} style={{
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid rgba(255, 255, 255, 0.08)',
                            padding: '40px',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%'
                        }}>
                            <div style={{ marginBottom: '24px' }}>{feature.icon}</div>
                            <h3 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '24px' }}>{feature.title}</h3>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '16px', flexGrow: 1 }}>
                                {feature.improvements.map((text, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', fontSize: '15px', color: 'rgba(255, 255, 255, 0.7)' }}>
                                        <CheckCircle2 size={16} color="#00FFD1" style={{ marginTop: '3px', flexShrink: 0 }} />
                                        {text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Sección de Ecosistemas Soportados */}
                <div style={{
                    marginTop: '100px',
                    textAlign: 'center',
                    padding: '40px',
                    background: 'rgba(0, 255, 209, 0.03)',
                    border: '1px solid rgba(0, 255, 209, 0.1)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '40px', flexWrap: 'wrap', opacity: 0.6 }}>
                        <span style={{ fontWeight: 700, letterSpacing: '2px' }}>ODOO</span>
                        <span style={{ fontWeight: 700, letterSpacing: '2px' }}>SAP B1</span>
                        <span style={{ fontWeight: 700, letterSpacing: '2px' }}>MICROSIP</span>
                    </div>
                </div>

                <footer style={{ marginTop: '60px', textAlign: 'center' }}>
                    <p style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '14px' }}>
                        <span style={{ color: '#00FFD1' }}>//</span> Pixelinux ERP Shield: Gestión proactiva de sistemas críticos para la empresa moderna.
                    </p>
                </footer>
            </main>
        </div>
    );
};

export default ServiceERP;
